import type { ComponentResolver } from 'unplugin-vue-components'

export function SbergResolver(): ComponentResolver {
  return {
    type: 'component',
    resolve: (name: string) => {
      if (name.match(/^The[A-Z]/))
        return { name, from: '@thenightex/vite-comp-lib' }
    },
  }
}